import styled, { css } from "styled-components";
import { media } from "../styles/media"; // 생성한 미디어 쿼리 헬퍼 가져오기


/******************************************************************/
/************************ 메인 배치 레이아웃 ************************/
/******************************************************************/

// 메인 영역 백그라운드
export const BackgroundArea = styled.div`
    /* 모바일 기본 */
    width: 100vw;
    height: 100vh;

    background: var(--DarkNavy, #1B1F38);

    /* 🔑 핵심: 자식 배치를 위한 기준점 설정 */
    position: relative;     

    /* 🔑 Flexbox를 사용해 내부 요소 배치 */
    // display: flex;
    align-items: center; /* 가운데 정렬 */    


    /* 태블릿 배치 */
    ${media.tablet`
        width: 100%;
        height: 860px;

        // background: var(--BGGray, #b3bdc78e);
        background: var(--DarkNavy, #1B1F38);

        /* 🔑 핵심: 자식 배치를 위한 기준점 설정 */
        position: relative;     

        /* 🔑 Flexbox를 사용해 내부 요소 배치 */
        display: flex;
        // flex-direction: column; /* 세로 방향으로 요소 배치 */
        // justify-content: flex-end; /* 아래쪽으로 요소를 몰아넣음 */    
        align-items: center; /* 가운데 정렬 */           
    `}

    /* 데스크탑 배치 */
    ${media.desktop`
        width: 1920px;
        height: 1080px;

        // background: var(--BGGray, #b3bdc78e);
        background: var(--DarkNavy, #1B1F38);

        /* 🔑 핵심: 자식 배치를 위한 기준점 설정 */
        position: relative;     

        /* 🔑 Flexbox를 사용해 내부 요소 배치 */
        display: flex;
        flex-direction: column; /* 세로 방향으로 요소 배치 */
        // justify-content: flex-end; /* 아래쪽으로 요소를 몰아넣음 */    
        align-items: center; /* 가운데 정렬 */           
    `}
`;

/******************************************************************/
/*************************** 각 영역 **************************/
/******************************************************************/

// 각 영역 백그라운드
export const LogoArea = styled.div`
    display: flex;
    // width: 186px;
    height: 40px;
    padding: 100px 0px 50px 0;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    /* 태블릿 배치 */
    ${media.tablet`
        flex-direction: column;
        justify-content: flex-end;
        gap: 443px;
        flex: 1 0 0;
    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

export const LogoFrame = styled.span`
    width: 184.606px;
    height: 38.886px;
    flex-shrink: 0;
    /* LogoLeft와 LogosubFrame을 가로로 배치 */
    display: flex;
    flex-direction: row; 
    align-items: flex-end; /* 세로 중앙 정렬 */
    gap: 10px; /* LogoLeft와 LogosubFrame 사이 간격 */

    /* 태블릿 배치 */
    ${media.tablet`
        width: 354px;
        height: 178px;


    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

export const LogosubFrame = styled.span`
    width: 152.746px;
    height: 30.1px;
    flex-shrink: 0;

    /* Flexbox 설정 */
    display: flex;
    flex-direction: row; /* 기본 가로 배치 */
    // align-items: center; /* 세로 중앙 정렬 */
    // flex-wrap: wrap; /* 요소가 넘치면 다음 줄로 자동 줄 바꿈 */
    align-items: flex-start; /* 세로 정렬 기준 */    

    /* 태블릿 배치 */
    ${media.tablet`
        width: 174.286px;
        height: 54.181px;
    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

export const LogoTextsWrapper = styled.div`
    /* LogoText1과 LogoText2를 세로로 배치 */
    display: flex;
    flex-direction: column;
    // justify-content: flex-end; /* 텍스트들을 세로 중앙에 배치 */
    
    /* 필요하다면 LogoRight와의 정렬을 미세 조정할 수 있습니다. */
    align-items: flex-end;

    padding: 8px 0px 0px 10px;
    
    /* 태블릿 배치 */
    ${media.tablet`
    
    `}
`;


export const LogoLeft = styled.div<{$imgUrl: string;}>`
    width: 22.897px;
    height: 37.868px;
    flex-shrink: 0;
    // aspect-ratio: 22.90/37.87;

    background-image: url(${(props) => props.$imgUrl}); 

    background-repeat: no-repeat;
    background-size: contain; /* 또는 cover, 100% auto 등 */

    /* 태블릿 배치 */
    ${media.tablet`
        width: 120px;
        height: 172px;
    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

export const LogoRight = styled.span<{$imgUrl: string;}>`
    width: 74.839px;
    height: 29.556px;
    flex-shrink: 0;

    background-image: url(${(props) => props.$imgUrl}); 

    background-repeat: no-repeat;
    background-size: contain; /* 또는 cover, 100% auto 등 */

    /* 태블릿 배치 */
    ${media.tablet`
        width: 134.389px;
        height: 53.2px;
    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

export const LogoText1 = styled.span<{$imgUrl: string;}>`
    width: 54.185px;
    height: 11.287px;
    flex-shrink: 0;

    background-image: url(${(props) => props.$imgUrl}); 

    background-repeat: no-repeat;
    background-size: contain; /* 또는 cover, 100% auto 등 */

    /* 태블릿 배치 */
    ${media.tablet`
        width: 97.299px;
        height: 20.317px;
    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

export const LogoText2 = styled.span<{$imgUrl: string;}>`
    width: 73.166px;
    height: 15.52px;
    flex-shrink: 0;
    
    background-image: url(${(props) => props.$imgUrl}); 

    background-repeat: no-repeat;
    background-size: contain; /* 또는 cover, 100% auto 등 */

/* ✨ 핵심 스타일: LogosubFrame의 너비를 꽉 채워서 다음 줄로 넘기고, ✨ */
    /* ✨ LogosubFrame 내에서 이 요소만 오른쪽으로 정렬합니다. ✨ */
    width: 100%; /* 부모(LogosubFrame)의 전체 너비를 차지하여 다음 줄로 이동 */
    align-self: flex-end; /* 현재 행에서 오른쪽 끝으로 정렬 */
    text-align: right; /* (내부 텍스트 정렬 시 사용하지만 div이므로 flexbox 정렬이 우선) */

    /* 태블릿 배치 */
    ${media.tablet`
        width: 131.384px;
        height: 27.936px;
    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;


export const LoginArea = styled.div`
    display: flex;
    // width: 800px;
    height: 100%;
    padding: 48px 60px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 40px;
    flex-shrink: 0;

    border-radius: 28px 0 0 28px;
    background: var(--Grayscale-WT_FF, #FFF);

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;